import React from 'react';

import Box from '@mui/material/Box';

const HeaderPage = ({children}) => {
    return(
        <Box
        sx={{
          minWidth: '95%',
          marginBottom: 1,
          display: { xs: 'none', sm:'none', md: 'flex' },
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          alignSelf: 'center',
          padding: 1,
          borderRadius: 1,
          bgcolor: 'background.main',
          border: 1,
          borderColor: 'primary.border'
        }}
      >

        {children}

      </Box>
    );
};

export default HeaderPage;